module.exports = __webpack_public_path__ + "assets/img/3015.85a972c1.svg";